import PropTypes from 'prop-types';

function IFFruitActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M20.3554 9.73237H22.392C22.9866 9.70519 23.5686 9.55144 24.0991 9.28139C24.6296 9.01135 25.0964 8.63122 25.4683 8.1664C26.9658 6.26242 26.6107 3.31445 26.6107 3.31445C22.4176 3.31445 20.9501 5.2655 20.4709 7.01545C20.2408 7.90276 20.2015 8.82875 20.3554 9.73237Z"
                fill="#C5DB66"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.7199 20.4924C29.0793 20.0218 29.443 19.5854 29.8452 19.1532C29.8759 19.1075 29.8959 19.0555 29.9038 19.001C29.9118 18.9465 29.9073 18.8909 29.8909 18.8384C29.8745 18.7858 29.8465 18.7376 29.8089 18.6973C29.7714 18.657 29.7253 18.6257 29.6741 18.6056C29.0151 18.3873 28.4076 18.0237 28.4076 17.1594C28.407 17.0152 28.4243 16.8715 28.4589 16.7315C28.2105 16.5202 28.0101 16.2581 27.8714 15.9629C27.7326 15.6677 27.6587 15.3462 27.6545 15.0201C27.6581 14.693 27.7326 14.3705 27.8729 14.075C28.0133 13.7795 28.2161 13.518 28.4675 13.3086C28.0956 12.9343 27.88 12.4326 27.8642 11.9052C27.8642 11.3619 28.2921 10.8655 28.66 10.4676C28.66 10.4676 27.3465 9.27818 25.4725 10.9511C23.5984 12.6241 24.5568 19.3458 26.3581 20.1031C28.1594 20.8604 28.7199 20.4924 28.7199 20.4924Z"
                fill="white"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.4268 17.8311C26.4268 17.6856 26.5209 17.5401 26.4824 17.4032C26.2813 16.7657 25.5026 16.5475 25.5026 15.8843C25.5115 15.3635 25.7057 14.863 26.0503 14.4724C26.1161 14.395 26.1544 14.298 26.1591 14.1965C26.1637 14.0951 26.1345 13.9949 26.076 13.9119C25.8375 13.5754 25.7089 13.1734 25.708 12.7609C25.708 11.8581 27.2397 11.0752 28.3993 10.6858C28.467 10.6633 28.5287 10.6256 28.5796 10.5756C28.6304 10.5255 28.6691 10.4645 28.6927 10.3971C28.7163 10.3297 28.7241 10.2578 28.7155 10.187C28.7069 10.1161 28.6821 10.0482 28.6431 9.98839C28.3043 9.5074 27.8699 9.10147 27.3671 8.79595C26.8643 8.49044 26.3038 8.29191 25.7208 8.21277C25.6415 8.19949 25.5601 8.20756 25.4849 8.23613C25.4097 8.2647 25.3435 8.31275 25.293 8.37535C24.5471 9.18314 23.5156 9.66818 22.4177 9.7274H20.7534C20.6403 9.73194 20.5294 9.6948 20.4419 9.62303C20.3543 9.55126 20.2962 9.44985 20.2784 9.33804C20.2179 8.7215 20.2424 8.09956 20.3512 7.48968C20.3628 7.4289 20.3622 7.3664 20.3492 7.30589C20.3363 7.24537 20.3113 7.18807 20.2758 7.13739C20.2403 7.08671 20.1949 7.04368 20.1425 7.01085C20.09 6.97803 20.0315 6.95607 19.9704 6.9463C19.6168 6.88753 19.2591 6.85748 18.9007 6.85645C15.3067 6.85645 13.1845 7.99456 10.4975 10.2793C9.3423 11.2591 9.11981 11.2634 8.39673 12.7609C8.05942 13.5561 7.84865 14.3993 7.77205 15.2596C7.77205 15.6875 7.77205 17.476 7.77205 17.9894C7.8906 19.3185 8.22592 20.6193 8.76469 21.8402C9.46638 23.5516 9.62041 23.6586 10.8655 24.8352C13.1802 27.0472 15.572 28.3479 18.8964 28.3479C20.8347 28.3479 23.6628 27.9201 25.1347 26.5252C26.8461 24.9165 27.3981 22.1397 28.8571 20.2999C28.9298 20.2057 29.0111 20.1116 29.0881 20.0175C27.1242 20.1073 26.4268 18.751 26.4268 17.8311Z"
                fill="#E95CA2"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.1299 11.2342C14.4508 10.6908 10.0567 12.7103 10.523 17.0274C10.7541 18.7389 11.3531 19.1197 11.3531 19.1197C11.3531 19.1197 12.3671 14.2549 14.1299 11.2342Z"
                fill="white"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IFFruitActive;

IFFruitActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFFruitActive.defaultProps = {
    className: null,
    width: 28,
};
